import { apiEndpoint, publicApi } from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { ACCOUNT_SERVICE } from "../config/index.ts";

export const githubPublicApi = publicApi(
  { domain: API_DOMAIN, path: `${ACCOUNT_SERVICE.LABEL}/github/pub` },
  { ingestGithubEvent: apiEndpoint({ body: z.unknown(), response: z.void() }) },
);
